import { camelCase as camelCaseChange } from 'change-case'

export const camelCase = (str: string) =>
  camelCaseChange(str, { mergeAmbiguousCharacters: false })
